import { Component } from '@angular/core';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgTemplateOutlet } from '@angular/common';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'cr-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    imports: [FlexModule, NgTemplateOutlet, MatDivider]
})
export class PanelComponent {}

@Component({
    selector: 'cr-panel-header',
    template: '<ng-content></ng-content>',
    styleUrls: ['./panel.component.scss']
})
export class PanelHeaderComponent {}

@Component({
    selector: 'cr-panel-actions',
    template: `
		<ng-content accept="cr-panel-action"></ng-content>
	`,
    styleUrls: ['./panel.component.scss']
})
export class PanelActionsComponent {}

@Component({
    selector: 'cr-panel-action',
    template: `
		<ng-content></ng-content>
		<mat-divider vertical="true"></mat-divider>
	`,
    styleUrls: ['./panel.component.scss'],
    imports: [MatDivider]
})
export class PanelActionComponent {}

@Component({
    selector: 'cr-panel-body',
    template: '<ng-content></ng-content>',
    styleUrls: ['./panel.component.scss']
})
export class PanelBodyComponent {}
